












































import BaseLoading from '@/components/base/BaseLoading.vue';
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import ContentWrapper from '@/components/ContentWrapper.vue';
import SiteWrapper from '@/components/SiteWrapper.vue';
import { CourseLicenseTemplateSortColumns } from '@/jbi-shared/types/jtms.types';
import { SortOrder } from '@/jbi-shared/types/search.types';
import { Vue, Component } from 'vue-property-decorator';
import CourseLicenseTemplateList from './components/CourseLicenseTemplateList.vue';
import {
  CourseLicenseTemplateFilterOptions,
  CourseLicenseTemplateResponse
} from '@/jbi-shared/dto/jtms.dtos';
import { initialFilterState } from '@/store/modules/jtms/course-license-template/course-license-template.const';
import {
  CourseLicenseTemplatePaginationOptions,
  CourseLicenseTemplateQueryParams,
  PaginatedCourseLicenseTemplate
} from '@/store/modules/jtms/course-license-template/course-license-template.types';
import { Action, State } from 'vuex-class';
import {
  ApiState,
  PaginatorSpecs,
  SortEventData
} from '@/store/types/general.types';
import { RootState } from '@/store/store';
import { Pagination } from '@/store/modules/admin/types/admin.types';
import CourseLicenseTemplateSearch from './CourseLicenseTemplateSearch.vue';
import CreateCourseLicenseTemplateModal from './CreateCourseLicenseTemplateModal.vue';
import DeleteCourseLicenseTemplateModal from './DeleteCourseLicenseTemplateModal.vue';

@Component({
  components: {
    BaseLoading,
    SiteWrapper,
    ContentWrapper,
    BasePaginatorHoc,
    CourseLicenseTemplateList,
    CourseLicenseTemplateSearch,
    CreateCourseLicenseTemplateModal
  }
})
export default class JTMSCourseLicenseTemplate extends Vue {
  courseLicenseTemplateFilterParams: CourseLicenseTemplateFilterOptions = initialFilterState();
  courseLicenseTemplatePaginationOptions: CourseLicenseTemplatePaginationOptions = {
    limit: 50,
    page: 1,
    sortColumn: CourseLicenseTemplateSortColumns.NAME,
    sortOrder: SortOrder.ASC
  };

  queryParamsForCourseLicenseTemplates: CourseLicenseTemplateQueryParams = {
    ...this.courseLicenseTemplateFilterParams,
    ...this.courseLicenseTemplatePaginationOptions
  };

  @Action('courseLicenseTemplate/getPaginatedCourseLicenseTemplate')
  getPaginatedCourseLicenseTemplate!: (
    payload: CourseLicenseTemplateQueryParams
  ) => Promise<PaginatedCourseLicenseTemplate>;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.paginatedCourseLicenseTemplates
  )
  courseLicenseTemplates!: Pagination<CourseLicenseTemplateResponse>;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.apiState.getPaginatedCourseLicenseTemplates
  )
  getPaginatedCourseLicenseTemplatesApiState!: ApiState;

  get isLoading() {
    return this.getPaginatedCourseLicenseTemplatesApiState.loading;
  }

  get items() {
    if (this.courseLicenseTemplates) {
      return this.courseLicenseTemplates.items;
    }

    return [];
  }

  get totalCount() {
    if (this.courseLicenseTemplates) {
      return this.courseLicenseTemplates.totalItems;
    }

    return 0;
  }

  get CourseLicenseTemplateList() {
    return CourseLicenseTemplateList;
  }

  created() {
    this.getPaginatedCourseLicenseTemplate(
      this.queryParamsForCourseLicenseTemplates
    );
  }

  openCreateCourseLicenseTemplateModal() {
    this.$buefy.modal.open({
      parent: this,
      component: CreateCourseLicenseTemplateModal,
      hasModalCard: true,
      trapFocus: true,
      events: {
        refreshPage: () => {
          this.refreshList();
        }
      }
    });
  }

  openDeleteCourseLicenseTemplateModal(
    licenseTemplateToDelete: CourseLicenseTemplateResponse
  ) {
    this.$buefy.modal.open({
      parent: this,
      component: DeleteCourseLicenseTemplateModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        courseLicenseTemplate: licenseTemplateToDelete
      },
      events: {
        refreshPage: () => {
          this.refreshList();
        }
      }
    });
  }

  openUpdateCourseLicenseTemplateModal(
    licenseTemplateToEdit: CourseLicenseTemplateResponse
  ) {
    this.$buefy.modal.open({
      parent: this,
      component: CreateCourseLicenseTemplateModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        isEdit: true,
        courseLicenseTemplate: licenseTemplateToEdit
      },
      events: {
        refreshPage: () => {
          this.refreshList();
        }
      }
    });
  }

  refreshList() {
    this.getPaginatedCourseLicenseTemplate(
      this.queryParamsForCourseLicenseTemplates
    );
  }

  modifyQueryParams<T>(paramsMap: Map<string, T>) {
    for (const [key, value] of paramsMap.entries()) {
      if (key in this.queryParamsForCourseLicenseTemplates) {
        // Use type assertion to safely assign the value
        (this.queryParamsForCourseLicenseTemplates as Record<string, any>)[
          key
        ] = value;
      }
    }
  }

  handleFilter() {
    const map = new Map();
    map.set('page', 1);

    // Dynamically map each filter to the query params
    for (const [key, value] of Object.entries(
      this.courseLicenseTemplateFilterParams
    )) {
      map.set(key, value);
    }

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handleResetFilter() {
    this.courseLicenseTemplateFilterParams = initialFilterState();
  }

  handlePaginator(paginator: PaginatorSpecs) {
    const map = new Map();
    map.set('limit', paginator.perPage);
    map.set('page', paginator.page);

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handleSort(data: SortEventData) {
    const map = new Map();
    map.set('sortColumn', data.sortColumn);
    map.set('sortOrder', data.sortOrder);

    this.modifyQueryParams(map);
    this.refreshList();
  }
}
